/**
 * 和服务端进行交互
 *  它封装了全局 request拦截器、respone拦截器、统一的错误处理、统一做了超时，baseURL设置等
 * <pre>
 * 作者:wei yang
 * 邮箱:1205181727@qq.com
 * 日期:2015-11-02-下午3:29:34
 * 版权:广州百拓开源信息科技有限公司
 * </pre>
 */
import axios from 'axios'
import { Message } from 'element-ui'
import { tryHideFullScreenLoading, NProgressStartLoading, NProgressEndLoading } from './loading'
import store from '@/store'
import { getToken } from '@/utils/auth'

const TIMEOUT = 3000 * 200 * 3 // 请求超时（timeout）时间
/**
  * 创建axios实例
  */
const service = axios.create({
  timeout: TIMEOUT, // request timeout
  withCredentials: true, //  跨域安全策略，
  baseURL: '/wlySap',
  headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json;charset=utf-8'
  }
})

const pengdingRequest = new Map()

// 根据当前请求信息，生成请求 key
function generateReqKey(config) {
  const { method, url, params, data } = config
  const formdata = {}
  if (data instanceof FormData) {
    for (const [key, val] of data.entries()) {
      formdata[key] = val
    }
  }
  return [method, url, JSON.stringify(params), JSON.stringify(data), JSON.stringify(formdata)].join('&')
}

// 把当前请求信息添加到 pengdingRequest 对象中
function addPendingRequset(config) {
  const reqKey = generateReqKey(config)
  config.cancelToken =
    config.cancelToken ||
    new axios.CancelToken((cancel) => {
      if (!pengdingRequest.has(reqKey)) {
        pengdingRequest.set(reqKey, cancel)
      }
    })
}

// 检查是否存在重复请求，若存在取消请求
function removePendingRequest(config) {
  const reqKey = generateReqKey(config)
  if (pengdingRequest.has(reqKey)) {
    const cancelToken = pengdingRequest.get(reqKey)
    cancelToken(reqKey)
    pengdingRequest.delete(reqKey)
  }
}

service.interceptors.request.use(
  async config => {
    // removePendingRequest(config)
    // addPendingRequset(config)
    // 暂时使用固定账号查询
    // config.auth = {
    //   username: 'WANGPC',
    //   password: 'LZY888@@'
    // }
    // 防止缓存
    if (config.method.toUpperCase() === 'GET') {
      config.params = {
        ...config.params,
        _t: Date.parse(new Date()) / 1000
      }
    }
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['Tobacco-Token'] = getToken()
      config.headers['X-Auth-Token'] = getToken()
    }

    if (store.getters.role && !config.data?.role) {
      config.data && (config.data.role = store.getters.role?.ROLE)
    }

    // 确保withCredentials设置正确
    //config.withCredentials = true
    // 添加固定params
    // config.params = {
    //   'sap-client': 300
    // }

    NProgressStartLoading()
    return config
  },
  error => {
    // pengdingRequest.clear()
    tryHideFullScreenLoading()
    NProgressEndLoading()
    console.log(222)
    Promise.reject(error)
  }
)

/**
  * 响应(respone)拦截器
  */
service.interceptors.response.use(
  async response => {
    // if (response.data.MSGTYPE !== 'S') {
    //   Message.error(response.data.MESSAGE)
    // }
    // // console.log(response)
    // removePendingRequest(response.config)
    NProgressEndLoading()
    return response.data
  },
  // 异常处理
  async error => {
    // removePendingRequest(error.config || {})
    NProgressEndLoading()
    if (error.request?.status === 500) {
      Message.error('服务器过载！')
    }
    if (error.request?.status === 413) {
      Message.error('上传文件过大！')
    }
    return Promise.reject(error)
  }
)

export default service




// WEBPACK FOOTER //
// ./src/utils/sap-request.js